export function showOsanoCookiePreferences(): void {
  if (typeof window === 'undefined') {
    return
  }

  window.Osano?.cm?.showDrawer?.()
}
